import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import { useUserContext } from "../../context/user_context";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect } from "react";
import AllPackages from "../../components/user/packages/AllPackages";
import BackButton from "../../components/BackButton";


function Packages() {

  let navigate = useNavigate();

  const { usertoken, businessData } = useUserContext();

  const { owner_token } = businessData;

  useEffect(() => {
    if (usertoken !== owner_token) {
      navigate('/user/dashboard');
      setTimeout(() => {
        toast.info('Page not Authorized to User!!!');
      }, 10);
    }
  }, []);

  return (
    <>
      <AppWrapper
        pagename={"settings"}
        route={"upgrade"}
      >
        <StyledPackages>
          <Title title={"Packages"}
            btnName={"Billing"}
            link={'/user/settings/billing'}
          />

          <BackButton />

          <div className="container-fliud min-height-lg">
            <div className="pt-5 pry-text">
              <h4>Change your Business plan</h4>
              <p>Upgrade your Business Plan to suit your business needs.</p>
            </div>
            <AllPackages />
          </div>

        </StyledPackages>
      </AppWrapper>

    </>
  );
}

export default Packages;

const StyledPackages = styled.div`
  

`;